export default {"src":"/_next/static/media/Hi_Five.1b917c61.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};